'use client'
import React, { useEffect, useState } from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

interface PaginationProps {
  totalPages: number
  currentPage: number
  itemsPerPage: number
  onPageChange: (page: number) => void
}

const Pagination: React.FC<PaginationProps> = ({
  totalPages,
  currentPage,
  onPageChange,
}) => {
  const [activePage, setActivePage] = useState(currentPage)

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return
    setActivePage(page)
    onPageChange(page)
  }

  useEffect(() => {
    setActivePage(currentPage)
  }, [currentPage])

  return (
    <Flex className="my-5 justify-between">
      <Flex className="items-center gap-0.5">
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
          <Box
            key={page}
            as="button"
            w={3}
            borderRadius={'5px'}
            h={3}
            className="mx-1 flex items-center justify-center p-3 text-xs"
            backgroundColor={page === activePage ? 'lyk-green' : 'white'}
            color={page === activePage ? 'white' : '#3E3E3E'}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </Box>
        ))}
      </Flex>

      <Flex>
        <ChevronLeftIcon
          color={activePage === 1 ? '#9F9F9F' : '#3E3E3E'}
          onClick={() => activePage > 1 && handlePageChange(activePage - 1)}
          cursor={activePage === 1 ? 'not-allowed' : 'pointer'}
        />
        <ChevronRightIcon
          color={activePage < totalPages ? '#3E3E3E' : '#9F9F9F'}
          onClick={() =>
            activePage < totalPages && handlePageChange(activePage + 1)
          }
          cursor={activePage < totalPages ? 'pointer' : 'not-allowed'}
        />
        <Text className="text-sm font-normal text-[#656565]">
          Showing page {activePage} of {totalPages}
        </Text>
      </Flex>
    </Flex>
  )
}

export default Pagination
